module.exports = __webpack_public_path__ + "static/media/balance_5000000_10000000.eb9a560f.png";